(() => {
  let alreadyInitialized = false;

  const activationConditionsMet = () => window.swinger.config.client === 'erotik'
    && (
      window.swinger.user.getCurrency() === 'USD'
      || (
        !window.swinger.user.getCurrency()
        && window.swinger.user.getGeo() === 'US'
      )
    );

  const formatCurrency = (value) => {
    let locale = 'de';

    if (
      window.swinger
      && window.swinger.config
      && window.swinger.config.language
    ) {
      locale = window.swinger.config.language;
    }

    value = parseFloat(value, 10);

    let formatter;
    try {
      formatter = new Intl.NumberFormat(locale, {
        style: 'decimal',
        useGrouping: true,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    } catch (e) {
      formatter = {
        format: (value) => value,
      };
    }

    return formatter.format(parseFloat(value));
  };

  const reformatHTML = (html) => {
    if (window.swinger.config.environment !== 'x-templates' && !activationConditionsMet()) {
      return html;
    }

    // de formatting
    const fractionalMatches = html.match(/[\d.,]+[.,]\d+\s*?€/g, '$1');
    if (fractionalMatches !== null) {
      fractionalMatches.forEach((match) => {
        const unit = match.match(/([\d.,]+)[.,]\d+\s*?€/, '$1')[1].replace(/[.,]/g, '');
        const subUnit = match.match(/[\d.,]+[.,](\d+)\s*?€/, '$1')[1];
        const value = (Number(unit) * 100 + Number(subUnit)) / 100;

        html = html.replace(match, `${formatCurrency(value)} $`);
      });
    } else {
      const NonFractionalMatches = html.match(/\d+\s*?€/g, '$1');
      if (NonFractionalMatches !== null) {
        NonFractionalMatches.forEach((match) => {
          const unit = match.match(/(\d+)\s*?€/, '$1')[1];

          html = html.replace(match, `${unit} $`);
        });
      } else {
        html = html.replace(/€/g, '$');
      }
    }

    return html;
  };

  const init = () => {
    if (alreadyInitialized) {
      return;
    }

    alreadyInitialized = true;

    window.swinger.observer.initialize('*', (elem) => {
      Array.prototype.slice.call(elem.childNodes)
        .filter((node) => node.nodeType === 3)
        .filter((node) => node.nodeValue.indexOf('€') > -1)
        .forEach((node) => {
          node.nodeValue = window.swinger.currency.reformatHTML(node.nodeValue);
        });
    }, false);
  };

  window.swinger = {
    ...window.swinger,
    currency: {
      reformatHTML,
      formatCurrency,
      currencySymbol: () => {
        switch (window.swinger.config.currency) {
          default:
            return '€';

          case 'USD':
            return '$';
        }
      },
    },
  };

  if (activationConditionsMet()) {
    init();
    return;
  }

  document.addEventListener('swinger.user:authchange', init, true);
})();
